import React from 'react';
import { Col, Row, Tabs, Typography } from 'antd';
import ReactPlayer from 'react-player';
import './index.less';
import { map } from 'lodash';
import bgImg from '../../assets/img/resourcesImg.png';
import Img from '../../assets/img/presentation.png';
import Img2 from '../../assets/img/presentation2.png';

export default function Resources() {
  const { Title } = Typography;
  const { TabPane } = Tabs;
  const videoData = [
    {
      url: 'https://www.youtube.com/watch?v=tbspjXF40_c',
      title: 'Building a Serverless IIoT GraphQL API using Elasticsearch and AWS',
      date: '19 May, 2019',
    },
  ];
  const presentationData = [
    {
      url: 'https://www.youtube.com/watch?v=a3MZ849gF6I',
      title: 'Internet of Energy: Can python prevent California wildfires?',
      date: '17 March, 2020',
    },
  ];
  const videoMap = map(videoData, data => (
    <div className="latest-videos">
      <div className="video">
        <ReactPlayer url={data.url} width="100%" height="100%" />
      </div>
      <Typography className="video-content">
        <Title level={4}>{data.title}</Title>
        <span>
          <p>{data.date}</p>
        </span>
      </Typography>
    </div>
  ));
  const presentationMap = map(presentationData, data => (
    <div className="latest-videos">
      <div className="video">
        <ReactPlayer url={data.url} width="100%" height="100%" />
      </div>
      <Typography className="video-content">
        <Title level={4}>{data.title}</Title>
        <span>
          <p>{data.date}</p>
        </span>
      </Typography>
    </div>
  ));
  return (
    <Row className="resource-block" justify="center" align="middle">
      <Col id="goTechnicalResources" xxl={22} xl={21} lg={22} md={22} sm={20} xs={23} className="resource-header">
        <Typography>
          <Title level={2}>Technical Resources</Title>
        </Typography>
      </Col>
      <Col xxl={22} xl={21} lg={22} md={22} sm={20} xs={23} className="resource-content">
        <Col className="video-block">{videoMap}</Col>
        <Col className="presentation-block">{presentationMap}</Col>
      </Col>
      <Col className="tabs" sm={{ span: 18, offset: 3 }} xs={22}>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Latest Presentations" key="2" className="presentation-block">
            <div className="tab-box">{videoMap}</div>
            <div className="tab-box">{presentationMap}</div>
          </TabPane>
        </Tabs>
      </Col>
      <div className="technicalImg">
        <img src={bgImg} className="bgImg" />
      </div>
    </Row>
  );
}
